import { render } from "./HelloWorld.vue?vue&type=template&id=0395cffa&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=0395cffa&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Fabiano\\Desktop\\Project\\machadofretesemudancas\\machadofretesemudancas\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0395cffa"]])

export default __exports__